var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewsroom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 48,
    height: 48,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5,33.5h9v-3h-9Zm20,0h3v-3h-3Zm-20-8h9v-3h-9Zm20,0h3v-11h-3Zm-20-8h9v-3h-9ZM6.6,42a2.88,2.88,0,0,1-2.1-.9A2.88,2.88,0,0,1,3.6,39V9a2.88,2.88,0,0,1,.9-2.1A2.88,2.88,0,0,1,6.6,6H41.4a2.88,2.88,0,0,1,2.1.9A2.88,2.88,0,0,1,44.4,9V39a3.08,3.08,0,0,1-3,3Zm0-3H41.4V9H6.6Zm0,0v0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsroom);
export default __webpack_public_path__ + "static/media/newsroom.f14b5f8b8039c8d84ce9bf1a54d17144.svg";
export { ForwardRef as ReactComponent };